/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetApplicationsQuery,
  ApplicationsFilterInput,
  ApplicationsSortInput,
} from "~/generated/graphql";

type Props = {
  page: number;
  limit: number;
  sort?: ApplicationsSortInput;
  filter?: ApplicationsFilterInput;
};

export function useGetApplications({ page, limit, sort, filter }: Props) {
  const { data, loading, error } = useGetApplicationsQuery({
    variables: { page, limit, sort, filter },
  });
  const count = data?.applications?.pageInfo?.count ?? 0;

  return {
    data: data?.applications?.result ?? [],
    loading,
    error,
    count,
  } as const;
}
